<p *ngIf="error" role="alert" class="text-danger">{{ error }}</p>
<tt-page *ngIf="page">
    <form (ngSubmit)="search()">
        <tt-card class="col-xs-12 sp-0">
            <tt-input ttLabel="searchtext" ttType="search" [ttModel]="page.searchtext ?? ''" (ttModelChange)="onSearchChanged($event)">
                <ng-container buttons>
                    <tt-form-field-button ttIcon="fas fa-eraser" ttType="danger" (ttClick)="clearSearch()"></tt-form-field-button>
                    <tt-form-field-button [ttIcon]="searching ? 'fas fa-spinner fa-spin' : 'fas fa-search'" ttType="success" (ttClick)="search()"></tt-form-field-button>
                </ng-container>
            </tt-input>
        </tt-card>
    </form>
    <tt-list [ttData]="reports" ttBackStyle [ttGoto]="false" (ttClick)="openItem($event)"></tt-list>
</tt-page>
